///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, ElementRef, Renderer2 } from '@angular/core';
import { FoldersTreeService } from '../folders-tree/folders-tree.service';

@Component({
    selector: 'winde-tree-list-sidebar',
    styleUrls: ['./tree-list-sidebar.component.scss'],
    templateUrl: './tree-list-sidebar.component.html',
    standalone: false
})
export class GtthTreeListSidebarComponent {
    isOpened = true;

    constructor(
        private readonly elRef: ElementRef,
        private readonly renderer: Renderer2,
        private readonly foldersTreeService: FoldersTreeService
    ) {}

    expandAll() {
        this.foldersTreeService.expandAll();
    }

    collapseAll() {
        this.foldersTreeService.collapseAll();
    }

    toggleSidebar() {
        this.isOpened = !this.isOpened;
        const flexBasis = this.isOpened ? '20%' : 'auto';
        this.renderer.setStyle(this.elRef.nativeElement, 'flex-basis', flexBasis);
    }
}
